$(document).ready(function () {
  const client = algoliasearch(
    "WI85SCF99Q",
    "f8f6e4bdadc661b17a2653422e249926"
  );
  const index = client.initIndex("shopify_products");
  const typeOption = document.getElementById("pfpType");
  const typeTitle = document.getElementById("pfpTypeTitle");
  const manufacturerOption = document.getElementById("pfpManufacturer");
  const manufacturerTitle = document.getElementById("pfpManufacturerTitle");
  const seriesOption = document.getElementById("pfpSeries");
  const seriesTitle = document.getElementById("pfpSeriesTitle");
  const modelOption = document.getElementById("pfpModel");
  const modelTitle = document.getElementById("pfpModelTitle");
  const collection = "Parts Finder";
  const yOffset = -10;

  let typeValue, manufacturerValue, seriesValue, modelValue;

  const searchForProduct = () => {
    window.location.href = `/products/${manufacturerValue
      .toLowerCase()
      .replace(" ", "-")}-${modelValue
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(".", "-")}-rubber-track`;
  };

  const searchForModels = async () => {
  const seriesFilter = seriesValue && seriesValue.toLowerCase() !== 'all' ? ` AND named_tags.Series:"${seriesValue}"` : '';
  index
  .searchForFacetValues("named_tags.Model", "", {
    filters: `named_tags.Part:"Rubber Track" AND named_tags.Manufacturer:"${manufacturerValue}" AND named_tags.Type:"${typeValue}"${seriesFilter}`,
  })
  .then((res) => {
    $(modelOption).empty();
    const { facetHits } = res;

    if (facetHits.length === 0) {
      modelOption.classList.remove("show");
      modelTitle.classList.remove("show");
      searchForProduct();
    } else {
      modelOption.classList.add("show");
      modelTitle.classList.add("show");
      modelTitle.scrollIntoView({ behavior: "smooth", block: "center" });

      facetHits.map((cat) => {
        var opt = document.createElement("a");
        opt.setAttribute("href", cat.value);
        opt.classList.add("part-finder-option");
        opt.innerText = cat.value;
        opt.addEventListener("click", (e) => {
          e.preventDefault();
          modelValue = e.target.getAttribute("href");
          searchForProduct();
        });
        modelOption.appendChild(opt);
      });
    }
  });
};

  const searchForSeries = async () => {
  index
      .searchForFacetValues("named_tags.Series", "", {
        filters: `named_tags.Part:"Rubber Track" AND named_tags.Type:"${typeValue}" AND named_tags.Manufacturer:"${manufacturerValue}"`,
      })
  .then((res) => {
    $(seriesOption).empty();
    const { facetHits } = res;
        if (
          facetHits.length === 0 ||
          (facetHits.length === 1 && facetHits[0].value.toLowerCase() === "all")
        ) {
          seriesOption.classList.remove("show");
          seriesTitle.classList.remove("show");
          searchForModels();
        } else {
          seriesOption.classList.add("show");
          seriesTitle.classList.add("show");
          seriesTitle.scrollIntoView({ behavior: "smooth", block: "center" });
          facetHits.map((cat) => {
            var opt = document.createElement("a");
            opt.setAttribute("href", cat.value);
            opt.classList.add("part-finder-option");
            opt.innerText = cat.value;
            opt.addEventListener("click", (e) => {
              e.preventDefault();
              seriesValue = e.target.getAttribute("href");
              searchForModels();
            });
            seriesOption.appendChild(opt);
          });
        }
      });
  };

  const searchForManufacturer = () => {
    manufacturerOption.classList.add("show");
    manufacturerTitle.classList.add("show");
    manufacturerTitle.scrollIntoView({ behavior: "smooth", block: "center" });
    index
      .searchForFacetValues("named_tags.Manufacturer", "", {
        filters: `named_tags.Part:"Rubber Track" AND named_tags.Type:"${typeValue}"`,
      })
      .then((res) => {
        $(manufacturerOption).empty();
        const { facetHits } = res;
        facetHits.map((cat) => {
          var opt = document.createElement("a");
          opt.setAttribute("href", cat.value);
          opt.classList.add("part-finder-option");
          opt.innerText = cat.value;
          opt.addEventListener("click", (e) => {
            e.preventDefault();
            manufacturerValue = e.target.getAttribute("href");
            searchForSeries();
          });
          manufacturerOption.appendChild(opt);
        });
      });
  };

  const searchForType = () => {
    index
      .searchForFacetValues("named_tags.Type", "", {
        filters: `named_tags.Part:"Rubber Track"`,
      })
      .then((res) => {
        const { facetHits } = res;
        facetHits.map((cat) => {
          var opt = document.createElement("a");
          opt.setAttribute("href", cat.value);
          opt.classList.add("part-finder-option");
          opt.innerText = cat.value;
          opt.addEventListener("click", (e) => {
            e.preventDefault();
            typeValue = e.target.getAttribute("href");
            searchForManufacturer();
          });
          typeOption.appendChild(opt);
        });
      });
  };

  if (typeOption) {
    searchForType();
  }
});
